import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jiankong3",
  "use": "icon-jiankong3-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiankong3\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 64V640H896V64H64zM0 0h960v704H0V0z\" p-id=\"2587\" /><path d=\"M192 896H768v64H192zM448 640H512v256h-64z\" p-id=\"2588\" /><path d=\"M479.232 561.604267l309.9904-348.330667-47.803733-42.5472-259.566934 291.669333L303.957333 240.008533 163.208533 438.6048l52.224 37.009067 91.6224-129.28z\" p-id=\"2589\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-jiankong3.svg
// module id = asq8
// module chunks = 120